import { render, staticRenderFns } from "./ProductTablesV2.vue?vue&type=template&id=2d58ab52&"
import script from "./ProductTablesV2.vue?vue&type=script&lang=js&"
export * from "./ProductTablesV2.vue?vue&type=script&lang=js&"
import style0 from "./ProductTablesV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports